import type { Maybe, ProductInterface } from '@pylot-data/pylotschema'
import { getStoreConfig } from 'config'
import stringify from 'fast-json-stable-stringify'
import { deepValue, itemHasKey } from '@corratech/pylot-utils/src/deep-value'

const getProductKey = (
    key: string,
    item: Maybe<ProductInterface>,
    attributes: Array<keyof ProductInterface>
): string => {
    if (!item) {
        return key
    }
    const keyItem: Record<string, unknown> = {}
    // Get the values of  all the attributes, specified in the store config
    attributes.forEach((attribute) => {
        if (itemHasKey(item, attribute)) {
            keyItem[attribute] = item[attribute]
        }
    })
    // json-stable-stringify uses sorting before stringification, which ensures stable results
    return `${key}|${stringify(keyItem)}`
}

// Generate a unique identifier for a set of products with specific order (key1|key2|...)
export const getKeyString = (items: Maybe<ProductInterface>[]): string => {
    const keyAttributes = deepValue(
        getStoreConfig(),
        ['base', 'product', 'visibleListAttributes'], // Path in the config object
        ['sku', 'price_range', 'small_image', 'name', 'url_key'] // Default key attributes
    )
    return items.reduce(
        (key: string, item: Maybe<ProductInterface>) =>
            getProductKey(key, item, keyAttributes),
        ''
    )
}
